<template>
  <button
    class="rin-checkbox pointer"
    :class="disabled ? 'rin-checkbox--disabled' : ''"
    :data-cy="testSelector"
    :data-cy-index="testSelectorIndex"
    :disabled="disabled"
    @click.prevent.stop="clicked()">
    <img
      class="rin-checkbox__icon"
      :src="showIcon" />
    <span class="rin-checkbox__text">
      <slot></slot>
    </span>
  </button>
</template>

<script>
  import TIcons from '../../types/TIcons';

  export default {
    data() {
      return {
        icons: TIcons,
        toggled: false,
      };
    },
    computed: {
      showIcon() {
        return this.toggled ? this.icons.checkboxFull : this.icons.checkboxEmpty;
      },
    },
    props: {
      disabled: {
        default: false,
        type: Boolean,
      },
      icon: {
        default: null,
        type: String,
      },
      initialState: {
        default: ``,
        type: String,
      },
      testSelector: {
        default: ``,
        type: String,
      },
      testSelectorIndex: {
        default: -1,
        type: Number,
      },
      toggledProp: {
        default: false,
        type: Boolean,
      },
    },
    mounted() {
      this.toggled = this.initialState === `clicked`;
    },
    methods: {
      clicked() {
        this.toggled = !this.toggled;
        this.$emit(`click`);
      },
    },
    watch: {
      toggledProp: {
        handler() { this.toggled = this.toggledProp; },
        immediate: true,
      },
    },
  };
</script>

<style lang="less" scoped>
  @iconSize: 21px;

  .rin-checkbox {
    margin-right: 15px;
    margin-top: 10px;

    &--disabled {
      cursor: default;
    }

    &__icon {
      height: @iconSize;
      margin-right: 5px;
      width: @iconSize;
    }
  }
</style>
